import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full pt-12 pb-20 px-4 md:pt-20 md:pb-28 overflow-hidden bg-[#f2f1ee]" data-id="element-51">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-52">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-start text-left z-10" data-id="element-53">
          <span className="inline-block px-4 py-1.5 mb-6 font-medium tracking-wide rounded-full text-[13px] pl-[25px] pr-[25px] bg-[#df1189] text-[#FAF5EB]" data-id="element-54">
            Para mamás que trabajan y quieren cuidarse.
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] mb-6 text-[#030303]" data-id="element-55">
            Plan 21 Días... <br data-id="element-56" />
            Alta Proteína.<br data-id="element-57" />
            <span className="italic text-[#030303] text-[28px] font-[700]" data-id="element-58">
              En freidora de aire.
            </span>
          </h1>

          <h2 className="text-xl md:text-2xl font-medium mb-6 text-[#0b0a0a]" data-id="element-59">
            Sistema 2×25: Domingo + Miércoles
          </h2>

          <p className="text-lg mb-8 max-w-lg leading-relaxed text-[#000000]" data-id="element-60">
            21 días de comidas altas en proteína, con sabor y sin cocinar
            diario: menú + listas del súper + tabla de tiempos + plan de
            emergencia.
          </p>

          <div className="flex flex-col w-full sm:w-auto gap-3" data-id="element-61">
            <a href="#pricing" className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 font-semibold rounded-xl shadow-lg hover:bg-terracotta-dark transition-all transform hover:-translate-y-0.5 text-lg group bg-[#df1189] text-[#FAF5EB]" data-id="element-62">
              Descarga Tu Plan
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-63" />
            </a>
            <p className="text-xs text-center sm:text-left mt-2 flex items-center justify-center sm:justify-start gap-2 text-[#050505]" data-id="element-64">
              Compra única - Descarga inmediata - PDF listo para usar.
            </p>
          </div>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative z-10 flex justify-center" data-id="element-65">
          <div className="relative" data-id="element-66">
            <div className="absolute inset-0 bg-terracotta/10 rounded-[2rem] transform rotate-3 scale-105 blur-xl" data-id="element-67"></div>
            <img src="https://cdn.magicpatterns.com/uploads/woGFti6yFmijGkhD14wXM7/Gemini_Generated_Image_ajkkumajkkumajkk.png" alt="Mujer sosteniendo iPad con el Plan 21 Días Alta Proteína" className="relative rounded-[1.5rem] shadow-2xl w-full max-w-md mx-auto transform hover:scale-[1.01] transition-transform duration-500" data-id="element-68" />

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-4 md:-right-8 bg-white p-4 rounded-xl shadow-xl border border-cream-dark max-w-[160px] hidden sm:block" data-id="element-69">
              <p className="text-sm font-serif italic text-terracotta font-bold text-center" data-id="element-70">
                "Tu problema no es la comida. Es decidir cansada."
              </p>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-white/40 to-transparent pointer-events-none" data-id="element-71"></div>
    </section>;
}